import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/sale/${dossierId}/SelfSupply/Component`, method: 'GET', token: token })
}
